// extracted by mini-css-extract-plugin
export default {"menu":"b1OWQ3","hasSections":"c1OWQ3","closed":"d1OWQ3","wider":"e1OWQ3"};